<div class="d-flex vh-100">
    <!-- Sidebar -->
    <nav class="sidebar text-white position-fixed position-lg-relative h-100 overflow-auto" 
        [class.sidebar-collapsed]="menuMin"
        id="sidebar">
        
        <!-- Header del Sidebar -->
        <div class="p-3 border-bottom border-light border-opacity-25">
            <div class="text-center" routerLink="/admin" role="button">
                <img src="/uncp-logo2.png" alt="UNCP Logo" class="img-fluid mb-2" style="max-height: 70px;">
                <h6 class="fw-bold mb-0 sidebar-title">{{env.institucion}}</h6>
            </div>
        </div>

        <!-- Menu Items -->
        <div class="sidebar-nav p-2">
        
            <!-- Sección Comedor -->
            <div class="mb-3">
                <h6 class="text-white-50 text-uppercase fw-bold px-2 mb-2 sidebar-section-title">
                    <i class="fas fa-cogs me-2"></i>Administración
                </h6>
                <nav class="nav flex-column">
                    <a routerLink="/admin" 
                        class="nav-link sidebar-link d-flex align-items-center py-2 px-3 rounded"
                        [class.active]="menuActive==1">
                        <i class="fas fa-tachometer-alt me-3"></i>
                        <span class="sidebar-text">Dashboard</span>
                    </a>

                    <a routerLink="usuarios" 
                        class="nav-link sidebar-link d-flex align-items-center py-2 px-3 rounded"
                        [class.active]="menuActive==2">
                        <i class="fas fa-user-tie me-3"></i>
                        <span class="sidebar-text">Usuarios</span>
                    </a>
                    
                    
                </nav>
            </div>

            <!-- Sección Registro -->
            <div class="mb-3">
                <h6 class="text-white-50 text-uppercase fw-bold px-2 mb-2 sidebar-section-title">
                    <i class="fas fa-database me-2"></i>Registro de Datos
                </h6>
                <nav class="nav flex-column">
                    <!-- Aquí van los enlaces de Registro de Datos -->
                    <a 
                        routerLink="conformidades" 
                        class="nav-link sidebar-link d-flex align-items-center py-2 px-3 rounded"
                        [class.active]="menuActive==11">
                        <i class="fas fa-envelope-open-text me-3"></i>
                        <span class="sidebar-text">Solicitudes</span>
                    </a>

                    <a 
                        routerLink="conformidades" 
                        class="nav-link sidebar-link d-flex align-items-center py-2 px-3 rounded d-none"
                        [class.active]="menuActive==12">
                        <i class="fas fa-check-circle me-3"></i>
                        <span class="sidebar-text">Atendidos</span>
                    </a>
                 
                </nav>
            </div>

            <!-- Sección Reporte -->
            <div class="mb-3">
                <h6 class="text-white-50 text-uppercase fw-bold px-2 mb-2 sidebar-section-title">
                    <i class="fas fa-chart-bar me-2"></i>Reportes
                </h6>
                <nav class="nav flex-column">
                    <!-- Aquí van los enlaces de Reportes -->
                    <!-- Dropdown de Reportes -->
                    <div class="dropdown">
                        <a class="nav-link sidebar-link d-flex align-items-center py-2 px-3 rounded dropdown-toggle" 
                        href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"
                        [class.active]="menuActive==7 || menuActive==8 || menuActive==9">
                        <i class="fas fa-file-alt me-3"></i>
                        <span class="sidebar-text">Reportes</span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-dark">
                            <li>
                                <a routerLink="reportes" class="dropdown-item" [class.active]="menuActive==7">
                                <i class="fas fa-university me-2"></i>Reporte por Facultades
                                </a>
                            </li>
                            <li>
                                <a routerLink="reportes_alumno" class="dropdown-item" [class.active]="menuActive==8">
                                <i class="fas fa-user-graduate me-2"></i>Reporte por Alumno
                                </a>
                            </li>
                            <li>
                                <a routerLink="listado" class="dropdown-item" [class.active]="menuActive==9">
                                <i class="fas fa-list-ul me-2"></i>Listado de Asistencia
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>

        </div>
    </nav>

    <!-- Overlay para móvil -->
    <div class="sidebar-overlay d-lg-none" 
        [class.show]="!menuMin" 
        (click)="toggleSidebar()">
    </div>

    <!-- Main Content -->
    <div class="flex-fill d-flex flex-column main-content" id="main-content">
        <!-- Header -->
        <header class="bg-dark text-white p-3 d-flex justify-content-between align-items-center">
            <!-- Botón hamburguesa y título del sistema -->
            <div class="d-flex align-items-center">
                <button class="btn btn-outline-light me-3" (click)="toggleSidebar()">
                    <i class="fas fa-bars"></i>
                </button>
                
                <!-- Título del sistema - Responsivo -->
                <div class="d-flex align-items-center">
                    <i class="fas fa-file-signature text-warning me-2 d-none d-md-block"></i>
                    <div>
                        <h5 class="mb-0 fw-bold d-none d-lg-block">{{env.appName}}</h5>
                        <h6 class="mb-0 fw-bold d-lg-none d-md-block">{{env.oficina}}</h6>
                        <small class="text-light d-block d-none d-lg-block">{{env.oficina}}</small>
                    </div>
                </div>
            </div>

            <!-- Usuario y opciones -->
            <div class="d-flex align-items-center">
                <!-- Información adicional en pantallas grandes -->
                <div class="text-end me-3 d-none d-xl-block">
                    <div class="small text-light">Bienvenido,</div>
                    <div class="fw-semibold">{{usuario.t1_name}}</div>
                </div>

                <!-- Dropdown del usuario -->
                <div class="dropdown">
                    <button class="btn btn-outline-light dropdown-toggle d-flex align-items-center" 
                            type="button" 
                            data-bs-toggle="dropdown" 
                            aria-expanded="false">
                        <i class="fas fa-user-circle me-2"></i>
                        <span class="d-inline">{{usuario.t1_email}}</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end py-0 overflow-hidden">
                        <li>
                            <h6 class="dropdown-header d-xl-none">
                                <i class="fas fa-user me-2"></i>{{usuario.t1_name}}
                            </h6>
                        </li>
                        <li><hr class="m-0"></li>
                        <li>
                            <button class="dropdown-item bg-danger text-white py-2" (click)="logout()">
                                <i class="fas fa-sign-out-alt me-2"></i>Cerrar Sesión
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </header>

        <!-- Content Area -->
        <main class="flex-fill p-0 overflow-auto">
            <router-outlet></router-outlet>
        </main>
    </div>

</div>